import React from 'react';
import { Badge } from '../ui/badge';
import { Tooltip, TooltipTrigger, TooltipContent } from '../ui/tooltip';
import { channelMeta } from './analysisData';

// The channel badge of a value; the tooltip names the source, the detail and what else was claimed.
export function ChannelBadge({ channel, source, detail, alternatives = [], conflict }) {
  if (!channel) return null;
  const meta = channelMeta(channel);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-help">
          <Badge variant={meta.variant} className="whitespace-nowrap">{meta.label}</Badge>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-sm space-y-1">
        <p className="text-ink-dim">{meta.hint}</p>
        {source && <p><span className="text-ink-mute">Source: </span>{source}</p>}
        {detail && <p><span className="text-ink-mute">Detail: </span>{detail}</p>}
        {conflict && <p className="text-warning">{conflict}</p>}
        {alternatives.length > 0 && (
          <div>
            <p className="text-ink-mute">Other sources:</p>
            {alternatives.map((a, i) => (
              <p key={i}>{a.text} <span className="text-ink-mute">· {channelMeta(a.channel).label}, {a.source}</span></p>
            ))}
          </div>
        )}
      </TooltipContent>
    </Tooltip>
  );
}

// A value with its channel badge, for table cells.
export function SourcedValue({ value, className = '' }) {
  if (!value) return <span className="text-ink-mute">—</span>;
  return (
    <span className={`inline-flex flex-wrap items-center gap-2 ${className}`}>
      <span className="font-bold text-ink">{value.text}</span>
      <ChannelBadge {...value} />
    </span>
  );
}
